import axios from 'axios';

function anonymousClient() {
  return axios.create({
    baseURL: window.env.API_URL,
    withCredentials: true,
  });
}

/** Password recovery is anonymous, including when a previous JWT has expired. */
export async function requestPasswordReset(email: string): Promise<void> {
  const client = anonymousClient();
  // Fetch for each submission: login or another tab can replace the CSRF cookie.
  const { data } = await client.get('auth/csrf/');
  const token = data?.csrfToken;
  if (typeof token !== 'string' || !token.trim()) {
    throw new Error('Password recovery could not be prepared. Please try again.');
  }
  await client.post('auth/password-reset/', { email: email.trim() }, {
    headers: { 'Content-Type': 'multipart/form-data', 'X-CSRFToken': token },
  });
}

export interface PasswordResetConfirmation {
  uid: string | undefined;
  token: string | undefined;
  new_password1: string;
  new_password2: string;
}

/** A valid recovery link must work without refreshing an old signed-in session. */
export async function confirmPasswordReset(payload: PasswordResetConfirmation, csrfToken: string | null): Promise<void> {
  await anonymousClient().post('auth/password/reset-confirm/', payload, {
    headers: { 'X-CSRFToken': csrfToken },
  });
}
